export const Paths = {
    default: '/faturamento/get_bplidassignedToInvoice',
    batch: '/faturamento/get_bplidassignedToInvoice_lote',
    serviceInfo: '/faturamento/get_serviceInfo',
};
